/* eslint-disable react-hooks/exhaustive-deps */
import { MouseEvent, useEffect, useState } from 'react';

import editImg from '../../../assets/edit.svg';
import trashImg from '../../../assets/trash_full.svg';

import { InputDateMask } from '../../Inputs/InputDateMask/InputDateMask';
import { Select } from '../../Select/Select';
import { DeleteModal } from '../../Modals/DeleteModal/DeleteModal';
import { EditModal } from '../../Modals/EditModal/EditModal';
import { CashModal } from '../../Modals/CashModal/CashModal';
import { InvoiceDataTable } from '../InvoiceDataTable/InvoiceDataTable';
import { ReadOnlyRow } from '../ReadOnlyRow/ReadOnlyRow';

import { IFaturas, useInvoicesTable } from '../../../context/TableContext';
import { useDevedor } from '../../../context/ConsultContext';

import {
  Container,
  FormTable,
  Table,
  FaturasTable,
  Faturas,
  ButtonActions,
  AddButton,
  TheadTable,
} from './styles';
import { useLoading } from '../../../hooks/useLoading';
import { Loader } from '../../Loader/Loader';
import { isValid, parse } from 'date-fns';

export const TableInvoices = () => {
  const {
    faturaParcelas,
    criarFatura,
    openDeleteModal,
    showDeleteModal,
    openParcelas,
    tableSelected,
    setTableSelected,
    showCashModal,
    showEditModal,
    showTable,
    setShowTable,
    page,
    criarFaturasAPI,
    listarFaturas,
    hasFaturaError,
    faturaError,
  } = useInvoicesTable();
  const { hideLoader, showLoader, loader } = useLoading();

  const { cpf, devedor } = useDevedor();

  const [showInput, setShowInput] = useState(true);
  const [submit, setSubmit] = useState(false);

  const [DOCUMENTO, setDOCUMENTO] = useState('');
  const [tipoContrato, setTipoContrato] = useState('');
  const [nInicial, setNInicial] = useState('');
  const [nFinal, setNFinal] = useState('');
  const [quantAberto, setQuantAberto] = useState(0);
  const [venciAberto, setVenciAberto] = useState('');
  const [proxVencimento, setProxVencimento] = useState('');
  const [valor, setValor] = useState('');

  useEffect(() => {
    setShowTable(false);
    setTableSelected(0);
  }, []);

  useEffect(() => {
    if (page === 'consulta') {
      setSubmit(true);
      setShowInput(false);
    } else {
      setSubmit(false);
      setShowInput(true);
    }
  }, [page]);

  useEffect(() => {
    listarFaturas(faturaParcelas);
  }, [faturaParcelas]);

  function closeDataTable() {
    setShowTable(false);
    setTableSelected(0);
  }

  function stringTipoDoc(tipoDoc: string) {
    switch (tipoDoc) {
      case 'Carnê':
        return 1;
      case 'Cheque':
        return 2;
      case 'N.Promissória':
        return 3;
      case 'CDC':
        return 4;
      case 'Duplicata':
        return 5;
      case 'Cartão de Crédito':
        return 6;
      default:
        return 0;
    }
  }

  async function onClickAddButton(
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
  ) {
    e.preventDefault();

    if (!submit) {
      if (
        DOCUMENTO === '' ||
        nInicial === '' ||
        nFinal === '' ||
        venciAberto === '' ||
        valor === ''
      ) {
        hasFaturaError(true);
        return;
      } else if (tipoContrato === 'Contrato' || tipoContrato === '') {
        hasFaturaError(true);
        return;
      } else if (!isValid(parse(venciAberto, 'dd/MM/yyyy', new Date()))) {
        hasFaturaError(true);
        return;
      }

      const quantParc = Number(nFinal) - Number(nInicial) + 1;

      if (quantParc < 0) {
        hasFaturaError(true);
        return;
      }

      showLoader();

      const valorParc = valor.replace(',', '.');

      const newInvoice: IFaturas = {
        documento: Number(DOCUMENTO),
        tipodoc: stringTipoDoc(tipoContrato),
        n_inicial: Number(nInicial),
        n_final: Number(nFinal),
        qtdeparc: quantParc,
        data1parc: venciAberto,
        valorparc: Number(valorParc),
      };

      if (page === 'register') {
        // eslint-disable-next-line array-callback-return
        const hasError = faturaParcelas.map((fatura) => {
          if (newInvoice.documento === fatura.fatura.documento) {
            hasFaturaError(
              true,
              'Já existe uma fatura com esse número de documento',
            );
            return true;
          }
        });

        if (hasError[0] === true) {
          hideLoader();
          return;
        } else {
          await criarFatura(newInvoice, Number(proxVencimento));
          setTableSelected(newInvoice.documento);
          hasFaturaError(false);
        }
      } else {
        await criarFaturasAPI(
          newInvoice,
          cpf,
          Number(proxVencimento),
          devedor.uf,
        );
        setTableSelected(newInvoice.documento);
      }

      setDOCUMENTO('');
      setTipoContrato('');
      setNInicial('');
      setNFinal('');
      setQuantAberto(0);
      setVenciAberto('');
      setProxVencimento('');
      setValor('');
    }
    setSubmit(!submit);
    setShowInput(!showInput);
    hideLoader();
  }

  return (
    <Container>
      <FormTable>
        <Table>
          <p>Dados da Faturas</p>

          <FaturasTable>
            <TheadTable hasFaturas={faturaParcelas.length === 0}>
              <tr>
                <th>Nº Contrato</th>
                <th>Tipo de contrato</th>
                <th>Parc. Inicial</th>
                <th>Parc. Final</th>
                <th>Quant. Parc. Aberto</th>
                <th>Venc. 1º Parc. Aberto</th>
                <th>Prox. Venc. Dias</th>
                <th>Valor Parcela</th>
                <th></th>
              </tr>
            </TheadTable>
            <tbody>
              {faturaParcelas?.map((fatura_parc) => (
                <Faturas
                  isSelected={tableSelected === fatura_parc.fatura.documento}
                >
                  <ReadOnlyRow
                    fatura_parc={fatura_parc}
                    key={fatura_parc.fatura?.documento}
                  />

                  <ButtonActions>
                    <button
                      type="button"
                      onClick={() => openParcelas(fatura_parc)}
                    >
                      <img src={editImg} alt="Editar" />
                    </button>
                    <button type="button">
                      <img
                        src={trashImg}
                        alt="Excluir"
                        onClick={() => openDeleteModal(fatura_parc)}
                      />
                    </button>
                  </ButtonActions>
                </Faturas>
              ))}

              {showInput && (
                <tr>
                  <td>
                    <input
                      type="text"
                      name="DOCUMENTO"
                      value={DOCUMENTO}
                      onChange={(e) => setDOCUMENTO(e.target.value)}
                    />
                  </td>

                  <td>
                    <Select
                      name="tipoContrato"
                      value={tipoContrato}
                      onChange={(e) => setTipoContrato(e.target.value)}
                      options={[
                        { value: '0', label: 'Contrato' },
                        { value: '1', label: 'Carnê' },
                        { value: '2', label: 'Cheque' },
                        { value: '3', label: 'N.Promissória' },
                        { value: '4', label: 'CDC' },
                        { value: '5', label: 'Duplicata' },
                        { value: '6', label: 'Cartão de Crédito' },
                      ]}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      name="nInicial"
                      value={nInicial}
                      onChange={(e) => setNInicial(e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      name="nFinal"
                      value={nFinal}
                      onChange={(e) => {
                        setNFinal(e.target.value);
                      }}
                      onBlur={(e) => {
                        setQuantAberto(Number(nFinal) - Number(nInicial) + 1);
                      }}
                    />
                  </td>

                  <td>
                    <p>{quantAberto}</p>
                  </td>

                  <td>
                    <InputDateMask
                      type="text"
                      name="venciAberto"
                      value={venciAberto}
                      onChange={(e) => setVenciAberto(e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      name="proxVencimento"
                      value={proxVencimento}
                      onChange={(e) => setProxVencimento(e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      name="valor"
                      value={valor}
                      onChange={(e) => setValor(e.target.value)}
                    />
                  </td>
                  <ButtonActions>
                    <img src={editImg} alt="Editar" />
                    <img src={trashImg} alt="Excluir" />
                  </ButtonActions>
                </tr>
              )}
            </tbody>
          </FaturasTable>
        </Table>

        <AddButton>
          <button
            className="add-fatura"
            type="button"
            onClick={(e) => onClickAddButton(e)}
          >
            Adicionar fatura
          </button>

          {showTable && (
            <button className="remove" onClick={() => closeDataTable()}>
              Remover Seleção
            </button>
          )}
        </AddButton>

        <span>{faturaError}</span>
      </FormTable>

      {showTable && <InvoiceDataTable />}
      <div className="modal">
        {showDeleteModal && <DeleteModal />}
        {showEditModal && <EditModal />}
        {showCashModal && <CashModal />}
      </div>
      {loader && <Loader />}
    </Container>
  );
};
